import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "my-4"
};
const _hoisted_2 = ["href"];
const _hoisted_3 = {
  class: "loading-spinner"
};
import { onMounted, reactive, ref } from "vue";
import LlIcon from "@/components/LlIcon.vue";
import LlSecondaryButton from "@/components/LlSecondaryButton.vue";
import { useUpgradeSubscriptionStore } from "./upgradeSubscriptionStore";
export default {
  __name: 'UpgradePlanDialog',
  props: {
    alerts: {
      type: Object,
      required: false
    },
    reportState: {
      type: Object,
      required: true
    }
  },
  emits: ["closeUpgradePlanDialog"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const upgradeSubscriptionStore = useUpgradeSubscriptionStore();
    upgradeSubscriptionStore.alerts = props.alerts;
    const dialog = ref(true);
    const emit = __emit;
    const advantages = ["Advanced roles", "Advanced reporting", "Compensation tracking", "LEDES billing", "Eligible for custom reports add-On", "Custom fields + matter based accounting"];
    const upgradePlanState = reactive({
      loading: false,
      accounts: []
    });
    onMounted(async () => {
      upgradePlanState.loading = true;
      await upgradeSubscriptionStore.listAccounts();
      upgradePlanState.accounts = upgradeSubscriptionStore.listEmailsWithSetupAccess();
      upgradePlanState.loading = false;
    });
    const closeDialog = () => {
      dialog.value = false;
      emit("closeUpgradePlanDialog", true);
    };
    return (_ctx, _cache) => {
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_list_item_content = _resolveComponent("v-list-item-content");
      const _component_v_list_item = _resolveComponent("v-list-item");
      const _component_v_list = _resolveComponent("v-list");
      const _component_v_col = _resolveComponent("v-col");
      const _component_v_row = _resolveComponent("v-row");
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_alert = _resolveComponent("v-alert");
      const _component_v_progress_circular = _resolveComponent("v-progress-circular");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_spacer = _resolveComponent("v-spacer");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      const _component_v_dialog = _resolveComponent("v-dialog");
      return _openBlock(), _createBlock(_component_v_dialog, {
        modelValue: dialog.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => dialog.value = $event),
        persistent: "",
        "max-width": "1000px"
      }, {
        default: _withCtx(() => [_createVNode(_component_v_card, {
          class: "overflow-auto"
        }, {
          default: _withCtx(() => [_createVNode(_component_v_card_title, {
            class: "title"
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode(" Upgrade your plan to ", -1), _createElementVNode("span", {
              class: "text-dark-yellow"
            }, "LeanLaw Pro", -1)]))]),
            _: 1
          }), _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [_cache[5] || (_cache[5] = _createElementVNode("p", null, " By upgrading to LeanLaw Pro, you can enjoy all the benefits of your current Core plan, as well as the following additional advantages: ", -1)), _createVNode(_component_v_row, {
              class: "flex-cards-row"
            }, {
              default: _withCtx(() => [_createVNode(_component_v_col, {
                cols: "12",
                md: "5"
              }, {
                default: _withCtx(() => [_createVNode(_component_v_list, null, {
                  default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(advantages, (item, idx) => {
                    return _createVNode(_component_v_list_item, {
                      key: idx
                    }, {
                      default: _withCtx(() => [_createVNode(LlIcon, {
                        icon: "mdi-check",
                        color: "primary",
                        class: "mr-1"
                      }), _createVNode(_component_v_list_item_content, null, {
                        default: _withCtx(() => [_createTextVNode(_toDisplayString(item), 1)]),
                        _: 2
                      }, 1024)]),
                      _: 2
                    }, 1024);
                  }), 64))]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), _createElementVNode("div", _hoisted_1, [_createVNode(_component_v_alert, {
              color: "#FBF1DF",
              text: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_v_icon, {
                class: "text-dark-yellow"
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("mdi-alert", -1)]))]),
                _: 1
              }), _cache[3] || (_cache[3] = _createElementVNode("span", {
                class: "font-bold"
              }, "Upgrade permission required!", -1)), _cache[4] || (_cache[4] = _createElementVNode("p", {
                class: "mt-2"
              }, " Please contact one of your colleagues with firm setup permission to upgrade your subscription plan: ", -1)), _createVNode(_component_v_row, null, {
                default: _withCtx(() => [_createVNode(_component_v_col, {
                  cols: "12",
                  md: "6"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(upgradePlanState.accounts, (account, idx) => {
                    return _openBlock(), _createElementBlock("div", {
                      key: idx
                    }, [_createElementVNode("span", null, _toDisplayString(account.name) + ":", 1), _createElementVNode("a", {
                      href: `mailto:${account.email}`,
                      class: "ml-2 text-dark-yellow"
                    }, _toDisplayString(account.email), 9, _hoisted_2)]);
                  }), 128))]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })]), upgradePlanState.loading ? (_openBlock(), _createBlock(_component_v_row, {
              key: 0
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_v_progress_circular, {
                style: {
                  "min-height": "300px"
                },
                size: 70,
                width: 7,
                color: "orange",
                indeterminate: ""
              })])]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          }), _createVNode(_component_v_card_actions, {
            class: "action"
          }, {
            default: _withCtx(() => [_createVNode(_component_v_spacer), _createVNode(LlSecondaryButton, {
              variant: "outlined",
              onClick: closeDialog
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("Close", -1)]))]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};